module.exports = __webpack_public_path__ + "static/media/arlicar3.878bd388.webp";